var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-btn-toggle',{model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},[_c('v-btn',[_vm._v(" To Do ")]),_c('v-btn',[_vm._v(" Archiv ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }